import styled from 'styled-components'

import { media, mediaMax } from 'styles/media'

import { countryLanderPath, marketLanderPath } from '../utils'
import { Title, EscapeLink, Item, List, Outer } from './shared'

export type LanderCountry = {
  code: string
  name: string
  markets?: Array<{
    code: string
    slug: string
    name: string
  }>
}

const ListsWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${mediaMax.md`
    ${List} {
      &:not(:first-child) {
        margin-top: 0;
      }
    }
  `}

  ${media.md`
    flex-direction: row;

    ${List} {
      &:not(:first-child) {
        margin-left: 200px;
      }
    }
  `}
`

type LanderLinksProps = {
  countries: LanderCountry[]
}

// Rendered on every home variant (including the post-hydration market swap)
// so the lander crawl graph is always present. The landers are edge-cached
// full pages; plain anchors keep client-side routing from re-rendering them
// against this page's stale seed.
const LanderLinks = ({ countries }: LanderLinksProps) => {
  return (
    <Outer>
      <Title>Escape in</Title>
      <ListsWrapper>
        {countries?.map(({ code: countryCode, name: countryName, markets }) => (
          <List columns={1} key={countryCode}>
            <Item>
              <EscapeLink as="a" href={countryLanderPath(countryCode)}>
                All {countryName}
              </EscapeLink>
            </Item>
            {markets
              ?.filter(
                (market) =>
                  marketLanderPath(market, countryCode) !==
                  countryLanderPath(countryCode),
              )
              ?.map((market) => (
                <Item key={market.code}>
                  <EscapeLink
                    as="a"
                    href={marketLanderPath(market, countryCode)}
                  >
                    {market.name}
                  </EscapeLink>
                </Item>
              ))}
          </List>
        ))}
      </ListsWrapper>
    </Outer>
  )
}

export default LanderLinks
